import styled from "styled-components";
import { useRef, useEffect } from "react";
import anime from 'animejs';
import { useInView } from 'react-intersection-observer';
import {mq} from '../util/media';

import Button from "../Button";
import LearnMoreButton from "../LearnMoreButton";
import GradientText from "../GradientText";
import SectionWrapper from "../SectionWrapper";
import SectionTitle from "../SectionTitle";

import {ReactComponent as CirclesImg} from "../../images/circles.svg";
import { useWindowSize } from "../util/viewsize";

const MainText = styled.p`
  font-size: 20px;
  line-height: 1.1;
  letter-spacing: 0.5px;
  margin: 0;
  margin-bottom: 24px;
  max-width: 38ch;

  ${mq.lt.md} {
    font-size: 15px;
  }

  ${mq.lt.sm} {
    text-align: center;
    font-size: 11px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;
  }

`

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;

  justify-content: center;


  ${mq.gt.xs} {
    gap: 2rem;
    justify-content: flex-start;
  }
`

const ImageContainer = styled.div`
  width: 200px;
  aspect-ratio: 1;
  margin: 0 auto;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
    height: 100%;
  }

  ${mq.gt.xs} {
    width: 100%;
  }

  transition: opacity 0.5s ease-in-out;
  &.hidden {
    opacity: 0;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  ${mq.lt.md} {
    margin: 45px 0;
  }

  ${mq.lt.sm} {
    & h2 {
      max-width: 12ch;
      margin-right: auto;
      margin-left: auto;
    }
  }
  transition: 0.7s ease-in-out;


  &.hidden {
    opacity: 0;
    transform: translateX(-10%); 
  }



`

const Inner = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${mq.gt.xs} {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 2rem;
    width: 100%;
    align-items: center;
  }

  ${mq.gt.sm} {
    grid-template-columns: 1fr 1fr;
  }
`

const CirclesImgStyle = styled(CirclesImg)`
  & path {
    transform-origin: center center;
  }

  & .upperCircle {
    filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 1));
  }
`

function animateGreyCircles(greyArray, colorArray) {
  anime({
    targets: greyArray,
    opacity: [0, 1],
    duration: 1,
    easing: 'linear',
    delay: anime.stagger(1),
    complete: () => {
      animateColorCircles(colorArray);
    }
  })

}

function animateColorCircles(colorArray) {
  for (let i = 0; i < 5; i++) {
    anime({
      targets: colorArray,
      opacity: 1,
      duration: 1
    })
    anime({
      targets: colorArray[i], 
      delay: 200 + (i * 100),
      easing: "easeOutQuad",
      strokeDashoffset: [anime.setDashoffset, 0],
      duration: (1000 + i * 300),
    });

  }
}




function OptimizedInterest() {

  const circleRef = useRef(null); 
  
  const [textRef, textInView] = useInView({
    triggerOnce: true,
    threshold: 0.6
  });

  const [imageRef, imageInView] = useInView({
    triggerOnce: true,
    threshold: 0.6
  });
  useEffect(() => {
    if (imageInView) {
      const greyCircles = Array.from(circleRef.current.children).slice(0, 5)
      const colorCircles = Array.from(circleRef.current.children).slice(-5)
  
      animateGreyCircles(greyCircles, colorCircles);
    }
  }, [imageInView]);

  const [ width ] = useWindowSize();

  return(
    <SectionWrapper smaller>

        <Inner>

          <InfoWrapper ref={textRef} className={textInView ? "" : "hidden" }>
            <SectionTitle constrain>Near Treasury offers <GradientText to="right" color1="#DC7ABA" color2="#E98E8D">optimized</GradientText><br/>
              <GradientText to="right" color1="#C66ED2" color2="#E19589">interest</GradientText>
            </SectionTitle>
            <MainText>
              Near Treasury’s yield is stable, {width < 1224 && width > 710 && <br /> } secure and attractive. {width > 1224 && <br /> } It is powered by staking returns and 3rd. generation arbitrage farming from multiple proof of stake blockchains &amp; DEX’s.
            </MainText>
            <ButtonContainer>
              <LearnMoreButton>Learn More</LearnMoreButton>
              <Button link="/webapp" type="webapp">WebApp</Button>
            </ButtonContainer>
          </InfoWrapper>

          <ImageContainer ref={imageRef} className={textInView ? "" : "hidden" }>
            <CirclesImgStyle ref={circleRef} />
          </ImageContainer>
          
        </Inner>

    </SectionWrapper>

  )
}

export default OptimizedInterest;